module.exports = __webpack_public_path__ + "static/media/hero_img_technical.34a646e0.png";